export const SUPPORTS_ARRAY_PROTOTYPE_SOME = "some" in Array.prototype;
